module.exports = __webpack_public_path__ + "img/shehui.fde25011.png";